import React from 'react';
import * as styles from './styles.module.scss';
import cls from "classnames"
import {getImage, StaticImage} from "gatsby-plugin-image";
import Img from "gatsby-image";

export type Props = {
  title: string
  details: string
  image: string
  description: string
  theme?: string
  className?: string
}

export const Review = ({ title, description, details, image, className, theme = 'light' }: Props) => {

  return (
    <div className={cls(styles.container, styles[theme], className)}>
      <img src={image} alt={title} className={styles.image} width={230} height={230}/>
      <div className={styles.content}>
        <div className={styles.head}>
          <p className={styles.title}>{title}</p>
          <p className={cls(styles.details)}>{details}</p>
        </div>
        <p className={cls(styles.description)}>{description}</p>
      </div>
    </div>
  )
}
